<template>
  <div class="WriteInfo_wrapper">
    <header>
      <div class="title">拍摄并上传您的有效二代身份证照片</div>
    </header>
    <div class="uploadPic">
      <van-uploader :after-read="afterRead" multiple>
        <div class="pic">
          <img src="../../assets/images/pic.jpg" />
        </div>
      </van-uploader>

      <div class="pic" v-for="(item, index) in imgList" :key="index">
        <img :src="item" />
      </div>
    </div>
    <footer>
      <div class="identify">
        <van-button type="primary" block class="btn" @click="upLoadOcr"
          >开始识别</van-button
        >
      </div>
    </footer>
  </div>
</template>

<script>
import "./WriteInformation.less";
import { Button, Toast, uploader, Dialog } from "vant";
import { upLoadOcr } from '../../api/api'
export default {
  name: "WriteInformation",
  data() {
    return {
      formData: '',
      imgList: []
    };
  },
  components: {
    "van-button": Button,
    "van-uploader": uploader,
  },
  methods: {
    afterRead(file) {
      if (Array.isArray(file)) {
        const fileList = new FormData();
        file.forEach(item => {
          fileList.append('file', item.file)
          this.imgList.push(item.content)
        })
        this.formData = fileList
      } else {
        const formData = new FormData();
        this.imgList.push(file.content)
        formData.append('file', file.file)
        this.formData = formData
      }
    },
    async upLoadOcr() {
      if (!this.imgList.length) {
        return
      }
      Toast.loading({
        message: '识别中...',
        forbidClick: true,
        duration: 0
      })
      const data = await upLoadOcr(this.formData)
      Toast.clear()
      if (+data.resCode === -1) {
        Dialog({ message: data.resMsg });
      } else {
        const ocrData = data.resData
        localStorage.setItem('ocrData', JSON.stringify(ocrData))
        this.$router.back(-1)
      }
    }
  },
};
</script>

<style>
</style>